import $api from "../http";
import { IGymListing } from "../models/GymListing";

class GymListingServiceClass {
  getGymListing(
    currentPage: number | undefined,
    pageSize: number | undefined,
    queryOptions?: {
      from: string | null;
      to: string | null;
      status: string | null;
      searchValue: string | null;
    }
  ) {
    let queryString = `currentPage=${currentPage}&pageSize=${pageSize}`;
    if (queryOptions) {
      if (queryOptions.from) {
        queryString += `&fromDate=${queryOptions.from}`;
      }
      if (queryOptions.to) {
        queryString += `&toDate=${queryOptions.to}`;
      }
      if (queryOptions.status) {
        queryString += `&status=${queryOptions.status}`;
      }
      if (queryOptions.searchValue) {
        queryString += `&searchValue=${queryOptions.searchValue}`;
      }
    }
    return $api.get<{ data: IGymListing[]; totalCount: number }>(`api/gym-listing?${queryString}`);
  }

  deleteById(id: string) {
    return $api.delete<{}>(`api/gym-listing/${id}`);
  }

  approveById(id: string) {
    return $api.put<{}>(`api/gym-listing/approve/${id}`);
  }

  declineById(id: string, model: { title: string; description: string }) {
    return $api.put<{}>(`api/gym-listing/decline/${id}`, model);
  }

  suspendById(id: string) {
    return $api.put<{}>(`api/gym-listing/suspend/${id}`, {});
  }

  unsuspendById(id: string) {
    return $api.put<{}>(`api/gym-listing/unsuspend/${id}`, {});
  }

  enableLastMinuteDeal(id: string) {
    return $api.put<{}>(`api/gym-listing/enable-last-min-deal/${id}`, {});
  }

  disableLastMinuteDeal(id: string) {
    return $api.put<{}>(`api/gym-listing/disable-last-min-deal/${id}`, {});
  }

  getGymListingById(id: string) {
    return $api.get<IGymListing | null>(`api/gym-listing/by-id/${id}`);
  }

  getGymListingPreviewById(id: string) {
    return $api.get<IGymListing>(`api/gym-listing/preview/${id}`);
  }

  getGymListingForAssignContractSelect() {
    return $api.get<{ id: string; label: string }[]>(`api/gym-listing/for-assign-contract-select`);
  }
}

export const GymListingService = new GymListingServiceClass();
